<template>
    <div class="main-panel">
        <div class="content-wrapper dashboard-shell">
            <div class="container-fluid py-4 px-3 px-md-4 cardplay recordatorios-card">
            <div class="header-card dashboard-header shadow-sm">
                <div class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3 w-100">
                    <div>
                        <p class="section-badge mb-2">Gestión de cobranza</p>
                        <h2 class="main-title mb-1">Recordatorios de pago</h2>
                        <p class="main-subtitle mb-0">
                            Beneficiarios a los que su pago corresponde al día
                            <span v-if="dateInput === formatearFecha(new Date())" class="highlight-text">
                                de hoy
                            </span>
                            <span v-else class="highlight-text">
                                {{ dateFormat(dateInput) }}
                            </span>
                        </p>
                    </div>

                    <div class="d-flex flex-wrap gap-2">
                        <button
                            class="btn btn-dark dashboard-download-btn btn-export"
                            @click="handleExportExcel"
                            :disabled="!ready || !creditos.length"
                        >
                            <i class="fa-solid fa-file-excel me-2"></i>
                            Exportar Excel
                        </button>
                    </div>
                </div>
            </div>

            <div class="filters-card shadow-sm mt-4">
                <div class="row dashboard-filters g-3 align-items-end">
                    <div class="col-12 col-md-4 col-lg-3 filter-item">
                        <label class="form-label custom-label">Fecha</label>
                        <input v-model="dateInput" type="date" class="form-control custom-input" />
                    </div>

                    <div class="col-12 col-md-4 col-lg-3 filter-item">
                        <label class="form-label custom-label">Mostrar</label>
                        <select v-model="cantidadMostrar" class="form-select custom-input dashboard-select">
                            <option :value="5">5</option>
                            <option :value="10">10</option>
                            <option :value="15">15</option>
                            <option :value="20">20</option>
                        </select>
                    </div>

                    <div class="col-12 col-md-4 col-lg-3 filter-item">
                        <label class="form-label custom-label">Sucursal</label>
                        <select v-model="sucursal" class="form-select custom-input dashboard-select">
                            <option value="MOSTRAR TODAS">MOSTRAR TODAS</option>
                            <option
                                v-for="(item, index) in sucursales"
                                :key="index"
                                :value="item"
                            >
                                {{ item }}
                            </option>
                        </select>
                    </div>

                    <div class="col-12 col-lg-3 filter-item">
                        <div class="info-chip">
                            <i class="fa-regular fa-calendar me-2"></i>
                            Fecha consultada: <strong class="ms-1">{{ dateFormat(dateInput) }}</strong>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row g-3 mt-1">
                <div class="col-12 col-md-4">
                    <div class="summary-card shadow-sm">
                        <div class="summary-icon bg-soft-blue">
                            <i class="fa-solid fa-users"></i>
                        </div>
                        <div>
                            <p class="summary-label mb-1">Total de créditos</p>
                            <h4 class="summary-value mb-0">{{ creditos.length }}</h4>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-md-4">
                    <div class="summary-card shadow-sm">
                        <div class="summary-icon bg-soft-green">
                            <i class="fa-solid fa-money-bill-wave"></i>
                        </div>
                        <div>
                            <p class="summary-label mb-1">Saldo vencido acumulado</p>
                            <h4 class="summary-value mb-0">L {{ formatoNumero(totalSaldoVencido) }}</h4>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-md-4">
                    <div class="summary-card shadow-sm">
                        <div class="summary-icon bg-soft-gold">
                            <i class="fa-solid fa-building"></i>
                        </div>
                        <div>
                            <p class="summary-label mb-1">Sucursal seleccionada</p>
                            <h4 class="summary-value mb-0 summary-branch">{{ sucursal }}</h4>
                        </div>
                    </div>
                </div>
            </div>

            <div class="list-card shadow-sm mt-4">
                <div class="list-header">
                    <div>
                        <h5 class="mb-1">Listado de beneficiarios</h5>
                        <p class="mb-0 text-muted">
                            Mostrando de {{ creditos.length ? desde + 1 : 0 }} a {{ limiteMostrado }} de {{ creditos.length }} registros
                        </p>
                    </div>
                </div>

                <div v-if="ready" class="list-body">
                    <div v-if="creditosPaginados.length">
                        <div
                            v-for="(credito, index) in creditosPaginados"
                            :key="index"
                            class="recordatorio-item"
                            @click="irCredito(credito.cliente.dni)"
                        >
                            <div class="recordatorio-top">
                                <span class="status-pill">PAGO PENDIENTE</span>
                            </div>

                            <div class="row g-3 align-items-center">
                                <div class="col-12 col-lg-3">
                                    <div class="data-block">
                                        <p class="data-label">Beneficiario</p>
                                        <h6 class="data-value mb-0">
                                            {{ credito.cliente.nombres }} {{ credito.cliente.apellidos }}
                                        </h6>
                                    </div>
                                </div>

                                <div class="col-6 col-md-4 col-lg-2">
                                    <div class="data-block">
                                        <p class="data-label">DNI</p>
                                        <p class="data-value mb-0">{{ credito.cliente.dni }}</p>
                                    </div>
                                </div>

                                <div class="col-6 col-md-4 col-lg-2">
                                    <div class="data-block">
                                        <p class="data-label">Sucursal</p>
                                        <p class="data-value mb-0">{{ credito.solicitud?.sucursal || '-' }}</p>
                                    </div>
                                </div>

                                <div class="col-6 col-md-4 col-lg-2">
                                    <div class="data-block">
                                        <p class="data-label">Teléfono</p>
                                        <p class="data-value mb-0">{{ credito.cliente.telefono || '-' }}</p>
                                    </div>
                                </div>

                                <div class="col-6 col-lg-3">
                                    <div class="data-block amount-block">
                                        <p class="data-label">Saldo vencido a pagar</p>
                                        <h6 class="amount-value mb-0">
                                            L {{ formatoNumero(credito?.simularPagoHoy?.minimoDebePagarCuota || 0) }}
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-else class="empty-state">
                        <i class="fa-regular fa-folder-open mb-3"></i>
                        <h5>No hay créditos para mostrar</h5>
                        <p class="mb-0">No se encontraron registros con los filtros seleccionados.</p>
                    </div>
                </div>

                <div v-else class="loading-state">
                    <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-3 mb-0">Cargando información...</p>
                </div>
            </div>

            <div v-if="ready && noPaginas > 1" class="pagination-card shadow-sm mt-4">
                <div class="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
                    <p class="mb-0 text-muted">
                        Página <strong>{{ noPagina }}</strong> de <strong>{{ noPaginas }}</strong>
                    </p>

                    <nav aria-label="Paginación">
                        <ul class="pagination modern-pagination mb-0">
                            <li class="page-item" :class="{ disabled: noPagina === 1 }">
                                <button class="page-link" @click="volver" type="button">
                                    <i class="fa-solid fa-chevron-left"></i>
                                </button>
                            </li>

                            <li
                                v-for="pagina in paginasVisibles"
                                :key="pagina"
                                class="page-item"
                                :class="{ active: pagina === noPagina }"
                            >
                                <button class="page-link" @click="opcion(pagina)" type="button">
                                    {{ pagina }}
                                </button>
                            </li>

                            <li class="page-item" :class="{ disabled: noPagina === noPaginas }">
                                <button class="page-link" @click="proximo" type="button">
                                    <i class="fa-solid fa-chevron-right"></i>
                                </button>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';
import ExcelJS from 'exceljs';
import Security from './security';

export default {
    data() {
        return {
            date: null,
            dateInput: '',
            ready: false,
            creditos: [],
            CreditosCompletos: [],
            sucursal: 'MOSTRAR TODAS',
            sucursales: [],
            sucursalesRoles: [],
            desde: 0,
            hasta: 5,
            noPaginas: 0,
            cantidadMostrar: 5,
            noPagina: 1,
        };
    },

    computed: {
        creditosPaginados() {
            return this.creditos.slice(this.desde, this.hasta);
        },

        limiteMostrado() {
            return Math.min(this.hasta, this.creditos.length);
        },

        totalSaldoVencido() {
            return this.creditos.reduce((acc, credito) => {
                return acc + Number(credito?.simularPagoHoy?.minimoDebePagarCuota || 0);
            }, 0);
        },

        paginasVisibles() {
            const total = this.noPaginas;
            const actual = this.noPagina;

            if (total <= 5) return Array.from({ length: total }, (_, i) => i + 1);
            if (actual <= 3) return [1, 2, 3, 4, total];
            if (actual >= total - 2) return [1, total - 3, total - 2, total - 1, total];
            return [1, actual - 1, actual, actual + 1, total];
        }
    },

    beforeMount() {
        const hoy = new Date();
        this.dateInput = this.formatearFecha(hoy);
        this.date = this.crearFechaUTCDesdeInput(this.dateInput);

        this.sucursalesRoles = Security.getUserSucursal();

        if (localStorage.getItem('cantidad_mostrar')) {
            this.cantidadMostrar = parseInt(localStorage.getItem('cantidad_mostrar'), 10);
        }

        if (localStorage.getItem('sucursal_recordatorio')) {
            this.sucursal = localStorage.getItem('sucursal_recordatorio');
        }

        this.hasta = parseInt(this.cantidadMostrar, 10);
        this.recordatorioPagoFetch(this.dateInput);
    },

    methods: {
        crearFechaUTCDesdeInput(fechaStr) {
            const [anio, mes, dia] = fechaStr.split('-').map(Number);
            return new Date(Date.UTC(anio, mes - 1, dia, 0, 0, 0));
        },

        recordatorioPagoFetch(fechaStr) {
            this.ready = false;

            const payload = {
                fechaRecordatorio: this.crearFechaUTCDesdeInput(fechaStr),
            };

            fetch(process.env.VUE_APP_API_URL + "/admin/recordatorios/pago", Security.requestOptions(payload))
                .then((response) => response.json())
                .then((response) => {
                    if (response.error) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: response.message,
                        });
                        this.ready = true;
                        return;
                    }

                    this.CreditosCompletos = response.data || [];
                    this.sucursales = this.obtenerSucursales(this.CreditosCompletos);
                    this.mostrarSucursal(this.sucursal);
                    this.ready = true;
                })
                .catch(error => {
                    this.ready = true;
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: error?.message || 'Ocurrió un error al cargar los recordatorios.',
                    });
                });
        },

        volver() {
            if (this.noPagina > 1) {
                this.opcion(this.noPagina - 1);
            }
        },

        proximo() {
            if (this.noPagina < this.noPaginas) {
                this.opcion(this.noPagina + 1);
            }
        },

        opcion(pagina) {
            this.noPagina = pagina;
            this.desde = (pagina - 1) * parseInt(this.cantidadMostrar, 10);
            this.hasta = pagina * parseInt(this.cantidadMostrar, 10);
        },

        formatoNumero(numero) {
            return new Intl.NumberFormat("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(Number(numero || 0));
        },

        formatearFecha(fecha) {
            if (typeof fecha === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
                return fecha;
            }

            if (fecha instanceof Date && !isNaN(fecha)) {
                const año = fecha.getFullYear();
                const mes = String(fecha.getMonth() + 1).padStart(2, '0');
                const dia = String(fecha.getDate()).padStart(2, '0');
                return `${año}-${mes}-${dia}`;
            }

            return '';
        },

        dateFormat(param) {
            if (!param) return '';

            if (typeof param === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(param)) {
                const [anio, mes, dia] = param.split('-');
                return `${dia}/${mes}/${anio}`;
            }

            const fecha = new Date(param);
            if (isNaN(fecha)) return '';

            const dia = String(fecha.getDate()).padStart(2, '0');
            const mes = String(fecha.getMonth() + 1).padStart(2, '0');
            const anio = fecha.getFullYear();

            return `${dia}/${mes}/${anio}`;
        },

        irCredito(dni) {
            this.guardarEnLocalStorage('busqueda', dni);
            window.open('/cartera', '_blank');
        },

        guardarEnLocalStorage(clave, valor, tamañoMaximo = 5 * 1024 * 1024) {
            const jsonString = JSON.stringify(valor);
            const tamañoJSON = new Blob([jsonString]).size;

            if (tamañoJSON <= tamañoMaximo) {
                localStorage.setItem(clave, jsonString);
            } else {
                console.error(`Error: El contenido excede el tamaño máximo permitido de ${tamañoMaximo} bytes.`);
            }
        },

        obtenerSucursales(creditos) {
            const todasLasSucursales = creditos
                .map(credito => (credito?.solicitud?.sucursal || '').toUpperCase().trim())
                .filter(Boolean)
                .filter((sucursal, index, array) => array.indexOf(sucursal) === index);

            if (this.sucursalesRoles?.[0]?.includes('ALL')) {
                return todasLasSucursales;
            }

            return todasLasSucursales.filter(sucursal =>
                this.sucursalesRoles?.[0]?.includes(sucursal)
            );
        },

        mostrarSucursal(sucursal) {
            if (!this.CreditosCompletos.length) {
                this.creditos = [];
            } else if (sucursal === 'MOSTRAR TODAS') {
                if (this.sucursalesRoles?.[0]?.includes('ALL')) {
                    this.creditos = [...this.CreditosCompletos];
                } else {
                    this.creditos = this.CreditosCompletos.filter(credito =>
                        credito.solicitud &&
                        this.sucursalesRoles?.[0]?.includes(credito.solicitud.sucursal)
                    );
                }
            } else {
                this.creditos = this.CreditosCompletos.filter(credito =>
                    credito.solicitud && credito.solicitud.sucursal === sucursal
                );
            }

            localStorage.setItem('sucursal_recordatorio', sucursal);
            this.reiniciarPaginacion();
        },

        reiniciarPaginacion() {
            this.noPaginas = Math.max(1, Math.ceil(this.creditos.length / this.cantidadMostrar));
            this.noPagina = 1;
            this.desde = 0;
            this.hasta = parseInt(this.cantidadMostrar, 10);
        },

        async handleExportExcel() {
            try {
                if (!this.creditos.length) {
                    Swal.fire({
                        icon: 'info',
                        title: 'Sin datos',
                        text: 'No hay registros para exportar.',
                    });
                    return;
                }

                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet("Recordatorios");

                worksheet.columns = [
                    { header: "Beneficiario", key: "beneficiario", width: 35 },
                    { header: "DNI", key: "dni", width: 18 },
                    { header: "Teléfono", key: "telefono", width: 18 },
                    { header: "Sucursal", key: "sucursal", width: 20 },
                    { header: "Saldo vencido a pagar", key: "saldoVencido", width: 22 },
                    { header: "Fecha recordatorio", key: "fechaRecordatorio", width: 18 },
                ];

                worksheet.getRow(1).font = { bold: true, color: { argb: 'FFFFFFFF' } };
                worksheet.getRow(1).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: '1F4E78' }
                };
                worksheet.getRow(1).alignment = { vertical: 'middle', horizontal: 'center' };

                const mappedData = this.creditos.map((credito) => ({
                    beneficiario: `${credito?.cliente?.nombres || ''} ${credito?.cliente?.apellidos || ''}`.trim(),
                    dni: credito?.cliente?.dni || '',
                    telefono: credito?.cliente?.telefono || '',
                    sucursal: credito?.solicitud?.sucursal || '',
                    saldoVencido: Number(credito?.simularPagoHoy?.minimoDebePagarCuota || 0),
                    fechaRecordatorio: new Date(this.dateInput + 'T00:00:00'),
                }));

                worksheet.addRows(mappedData);

                worksheet.getColumn('saldoVencido').numFmt = '#,##0.00';
                worksheet.getColumn('fechaRecordatorio').numFmt = 'dd/mm/yyyy';

                worksheet.eachRow((row, rowNumber) => {
                    row.alignment = { vertical: 'middle', horizontal: 'left' };

                    if (rowNumber > 1) {
                        row.eachCell((cell) => {
                            cell.border = {
                                top: { style: 'thin', color: { argb: 'FFE5E7EB' } },
                                left: { style: 'thin', color: { argb: 'FFE5E7EB' } },
                                bottom: { style: 'thin', color: { argb: 'FFE5E7EB' } },
                                right: { style: 'thin', color: { argb: 'FFE5E7EB' } }
                            };
                        });
                    }
                });

                worksheet.addTable({
                    name: 'RecordatoriosPagoTable',
                    ref: 'A1',
                    headerRow: true,
                    style: {
                        theme: 'TableStyleMedium2',
                        showRowStripes: true,
                    },
                    columns: worksheet.columns.map(col => ({
                        name: col.header,
                        filterButton: true
                    })),
                    rows: mappedData.map(row => worksheet.columns.map(col => row[col.key])),
                });

                const totalRowNumber = mappedData.length + 3;
                worksheet.getCell(`D${totalRowNumber}`).value = 'Total saldo vencido:';
                worksheet.getCell(`D${totalRowNumber}`).font = { bold: true };

                worksheet.getCell(`E${totalRowNumber}`).value = this.totalSaldoVencido;
                worksheet.getCell(`E${totalRowNumber}`).numFmt = '#,##0.00';
                worksheet.getCell(`E${totalRowNumber}`).font = { bold: true };

                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });

                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `Recordatorios-Pago-${this.formatearFecha(this.dateInput)}-${this.sucursal}.xlsx`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);

                Swal.fire({
                    icon: 'success',
                    title: 'Excel generado',
                    text: 'El reporte se descargó correctamente.',
                    timer: 1800,
                    showConfirmButton: false
                });
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error al exportar',
                    text: error?.message || 'No se pudo generar el archivo Excel.',
                });
            }
        },
    },

    watch: {
        dateInput(nuevaFecha) {
            if (!nuevaFecha) return;
            this.date = this.crearFechaUTCDesdeInput(nuevaFecha);
            this.recordatorioPagoFetch(nuevaFecha);
        },

        cantidadMostrar(nuevaCantidad, cantidadAnterior) {
            const valor = parseInt(nuevaCantidad || cantidadAnterior || 5, 10);
            this.cantidadMostrar = valor;
            localStorage.setItem('cantidad_mostrar', valor);
            this.reiniciarPaginacion();
        },

        sucursal(nuevaSucursal) {
            this.mostrarSucursal(nuevaSucursal);
        }
    }
};
</script>

<style scoped>
.dashboard-shell {
    background: linear-gradient(165deg, #f5f7fb 0%, #eef1f7 45%, #f8fafc 100%);
    min-height: 100vh;
}

.cardplay {
    border-radius: 24px;
    border: 1px solid #e5e7eb;
    padding: 32px;
    background-color: #ffffff;
    box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);
}

.recordatorios-card {
    color: #0f172a;
}

.header-card,
.filters-card,
.list-card,
.pagination-card,
.summary-card {
    background: #ffffff;
    border: 1px solid #e9eef5;
    border-radius: 16px;
}

.header-card,
.filters-card,
.list-card,
.pagination-card {
    padding: 1.25rem;
}

.dashboard-header {
    background: linear-gradient(120deg, #111827 0%, #1f2937 70%, #374151 100%);
    border-radius: 18px;
    margin-bottom: 24px;
    color: #fff;
}

.dashboard-filters {
    margin: 0;
}

.filter-item {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    padding: 12px;
}

.section-badge {
    display: inline-block;
    padding: 0.35rem 0.8rem;
    background: rgba(255, 255, 255, 0.16);
    color: #e2e8f0;
    border-radius: 999px;
    font-size: 0.85rem;
    font-weight: 600;
}

.main-title {
    font-size: 2rem;
    font-weight: 700;
    color: #ffffff;
}

.main-subtitle {
    color: #cbd5e1;
    font-size: 1.02rem;
}

.highlight-text {
    color: #ffffff;
    font-weight: 700;
}

.btn-export {
    background: #111827;
    color: white;
    border-radius: 999px;
    padding: 0.7rem 1.2rem;
    font-weight: 600;
    transition: 0.2s ease;
}

.btn-export:hover {
    background: #0f172a;
    color: white;
    transform: translateY(-1px);
}

.btn-export:disabled {
    background: #94a3b8;
    cursor: not-allowed;
}

.custom-label {
    font-size: 0.92rem;
    font-weight: 600;
    color: #334155;
}

.custom-input {
    height: 48px;
    border-radius: 14px;
    border: 1px solid #dbe3ee;
    background: #ffffff;
    box-shadow: none;
}

.custom-input:focus {
    border-color: #94a3b8;
    box-shadow: 0 0 0 0.2rem rgba(15, 23, 42, 0.08);
}

.dashboard-select {
    border-radius: 10px;
    border-color: #dbe2ea;
}

.info-chip {
    height: 48px;
    display: flex;
    align-items: center;
    padding: 0 1rem;
    border-radius: 14px;
    background: #ffffff;
    border: 1px solid #dbe2ea;
    color: #1e293b;
    font-size: 0.95rem;
}

.summary-card {
    padding: 1.2rem;
    display: flex;
    align-items: center;
    gap: 1rem;
    height: 100%;
    border: 1px solid #edf0f4;
    box-shadow: 0 10px 22px rgba(15, 23, 42, 0.08);
}

.summary-icon {
    width: 54px;
    height: 54px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
}

.bg-soft-blue {
    background: #eff6ff;
    color: #2563eb;
}

.bg-soft-green {
    background: #ecfdf5;
    color: #059669;
}

.bg-soft-gold {
    background: #fff7ed;
    color: #d97706;
}

.summary-label {
    font-size: 0.92rem;
    color: #64748b;
}

.summary-value {
    font-size: 1.45rem;
    font-weight: 700;
    color: #0f172a;
}

.summary-branch {
    font-size: 1rem;
    word-break: break-word;
}

.list-header {
    border-bottom: 1px solid #eef2f7;
    padding-bottom: 1rem;
    margin-bottom: 1rem;
}

.list-body {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.recordatorio-item {
    border: 1px solid #e8eef5;
    border-radius: 18px;
    padding: 1rem 1.1rem;
    background: #ffffff;
    transition: all 0.2s ease;
    cursor: pointer;
}

.recordatorio-item:hover {
    border-color: #bfd6ff;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
    transform: translateY(-1px);
}

.recordatorio-top {
    margin-bottom: 0.8rem;
}

.status-pill {
    display: inline-flex;
    align-items: center;
    padding: 0.35rem 0.75rem;
    border-radius: 999px;
    background: #eff6ff;
    color: #2563eb;
    font-size: 0.8rem;
    font-weight: 700;
    letter-spacing: 0.3px;
}

.data-block {
    background: #fbfdff;
    border: 1px solid #edf2f7;
    border-radius: 14px;
    padding: 0.85rem 0.95rem;
    min-height: 86px;
}

.data-label {
    margin-bottom: 0.35rem;
    font-size: 0.8rem;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    font-weight: 700;
}

.data-value {
    color: #0f172a;
    font-weight: 600;
    word-break: break-word;
}

.amount-block {
    background: #f8fffb;
    border-color: #d1fae5;
}

.amount-value {
    color: #059669;
    font-size: 1.05rem;
    font-weight: 700;
}

.loading-state,
.empty-state {
    min-height: 260px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #64748b;
    text-align: center;
}

.empty-state i {
    font-size: 2.3rem;
    color: #94a3b8;
}

.modern-pagination .page-link {
    border: none;
    min-width: 42px;
    height: 42px;
    border-radius: 12px !important;
    margin: 0 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #334155;
    background: #f8fafc;
    box-shadow: none;
}

.modern-pagination .page-item.active .page-link {
    background: #2563eb;
    color: white;
}

.modern-pagination .page-item.disabled .page-link {
    opacity: 0.5;
    pointer-events: none;
}

.modern-pagination .page-link:hover {
    background: #eaf2ff;
    color: #1d4ed8;
}

@media (max-width: 768px) {
    .cardplay {
        padding: 16px;
    }

    .main-title {
        font-size: 1.6rem;
    }

    .main-subtitle {
        font-size: 0.95rem;
    }

    .header-card,
    .filters-card,
    .list-card,
    .pagination-card {
        padding: 1rem;
    }
}
</style>
